<div class="saveNameList">
  <div class="header">
    <img src="/assets/images/save-list.svg" />
    <p *ngIf="!isEditMode" translate>apiExposure.savingNameField</p>
    <p *ngIf="isEditMode" translate>apiExposure.editingNameField</p>
  </div>
  <div class="contain">
    <p translate>questionBoard.edit.duplicate-popup.question-name</p>
    <div class="warp-select" #trigger>
      <div class="folder" (click)="isMenuOpen=true">
               <p *ngIf="fieldName.value; else placeholder">{{ getSelectedFieldName() }}</p>
        <ng-template #placeholder>
          <p class="placeholder" translate>apiExposure.selectField</p>
        </ng-template>
        <img src="/assets/images/steps/dropdown.svg" class="download-img" />
      </div>
    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
      cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isMenuOpen=false"
      [cdkConnectedOverlayOpen]="isMenuOpen" [cdkConnectedOverlayPositions]="positonArea">
      <div class="overlay-warp">
        <div *ngFor="let f of exposureFields()" class="item" (click)="selectField(f.id)">
          <p>{{ getFieldName(f) }}</p>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="footer">
    <div>
      <img *ngIf="isEditMode" class="pointer" src="/assets/images/question-menu/delete.svg" (click)="remove()" />
    </div>
    <div class="buttons">
      <div class="btn cancel pointer" (click)="cancel()" translate>
        questionBoard.edit.list-popup.cancel
      </div>
      <div [ngClass]="{ disable: !fieldName.valid }" class="btn save pointer" (click)="save()">
        <p translate>questionBoard.edit.list-popup.save</p>
      </div>
    </div>
  </div>
</div>